export let UnemployedLength = /*#__PURE__*/function (UnemployedLength) {
  UnemployedLength["LessTwelve"] = "less_tewlve";
  UnemployedLength["BetweenTwelveAndtwentyFour"] = "between_twelve_and_twenty_four";
  UnemployedLength["MoreTwentyFour"] = "more_twenty_four";
  return UnemployedLength;
}({});